import requests from './request-config'
import { onGoLoginPage } from '@/core/storage/ls'
import { getLsToken } from '@/core/storage/ls'
import { AUTH_TOKEN } from '@/core/storage/storage-key'
import storage from 'store2'

let localLocale = storage.get('locale') || 'en'

let headersMap = {
  'en': 'en',
  'zh-cn': 'zh',
  'fr': 'fr'
}

// 删除空值
function deleteEmptyKey (obj) {
  for (const key in obj) {
    const value = obj[key]
    if (value === '' || value === null || value === undefined) {
      delete obj[key]
    }
  }
}

// 去除字符串首尾空格（处理对象的一级字段）
function trimObjectValues(obj) {
  if (!obj || typeof obj !== 'object') return obj
  
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      if (typeof value === 'string') {
        obj[key] = value.trim()
      }
    }
  }
  return obj
}

function interceptorRequest(req) {
  const token = getLsToken()
  if (token) {
    if (req.headers) {
      req.headers[AUTH_TOKEN] = token
    }
  }
  if (req.params) {
    deleteEmptyKey(req.params)
  }
  // POST/PUT 请求去除 data 一级对象字段的首尾空格
  // GET 请求去除 params 一级对象字段的首尾空格
  const method = req.method?.toLowerCase()
  if ((method === 'post' || method === 'put') && req.data) {
    trimObjectValues(req.data)
  }
  if (method === 'get' && req.params) {
    trimObjectValues(req.params)
  }
  
  return req
}

const instance = new requests({
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'language': headersMap[localLocale]
  },
  baseURL: import.meta.env.VITE_VUE_APP_API_BASE_URL,
}, interceptorRequest)

const _request = instance.request.bind(instance)


// Auth-Token
export default async function (config, configObj) {
  const {error, result} = await _request(config, configObj)
  if (error) {
    // if (error.code === -1000 || error.code === -1009) {
    //   setTimeout(() => {
    //     onGoLoginPage()
    //   }, 1000)
    // }
  }
  return {error, result}
}